// extracted by mini-css-extract-plugin
module.exports = {"card":"ShareCta_card__327Ul","btnWrapper":"ShareCta_btnWrapper__ftcc_"};